import { ResponseTypes } from "../../services/APIEarlyWarningService";

const BASE_URL = process.env.REACT_APP_BASE_URL

const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

export type APIResponseUserType = {
    id: number | null;
    username: string;
    email: string;
    password: string | null;
    country: string;
    firstname: string;
    lastname: string;
    address: string;
    mobilenumber: string;
    organization: string;
    department: string;
    role: string;
    nic: string;
    policies: string;
    accessprivileges: string;
    thememodebconex: string;
    themecolorbconex: string;
    thememodeeaglei: string;
    profilePicUrl: string | null;
}

export const ApiGetAllUsers = async (): Promise<{status: boolean, data: APIResponseUserType[], message: string}> => {
    
    const URL: string = `${BASE_URL}/identity_manager/api/v1/getallusers`
    const HEADER: RequestInit = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        }
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseJson = await response.json()

        if (response.ok)
        {
            const responseData: APIResponseUserType[] = responseJson as APIResponseUserType[]
            
            return {status: true, data: responseData, message: "users' data found"}
        }
        else 
        {
            return {status: false, data: [], message: "failed to get users"}
        }
    }
    catch (error)
    {
        console.error("failed to retrieve user data with error [", error, "]")
        return {status: false, data: [], message: "failed to get users"}
    }
}

export type APIResponseWorkflowInfo = {
    warningId: string,
    username: string,
    hazardType: string,
    warningType: string,
    departments: string
}

export const ApiGetAllWorkflows = async (): Promise<{status: boolean, data: APIResponseWorkflowInfo[], message: string}> => {
    
    const URL: string = `${BASE_URL}/workflow_engine/api/v1/getallinformation`
    const HEADER: RequestInit = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        }
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseJson = await response.json() as ResponseTypes

        if (response.ok)
        {
            //console.log("RESPONSE -> ", responseJson)
            const responseData: APIResponseWorkflowInfo[] = responseJson.data as APIResponseWorkflowInfo[]
            return {status: true, data: responseData, message: "users' data found"}
        }
        else 
        {
            return {status: false, data: [], message: "failed to get users"}
        }
    }
    catch (error)
    {
        console.error("failed to retrieve user data with error [", error, "]")
        return {status: false, data: [], message: "failed to get users"}
    }
}

export type APIResponseUsersByUsername = {
    username: string;
    firstName: string;
    lastName: string;
    departmentName: string;
    departmentId: string;
    organizationName: string;
    organizationId: string;
    roleId: string;
    roleName: string;
}

export const ApiGetUsersByWorkflowId = async (id: string) => {
    const URL: string = `${BASE_URL}/workflow_engine/api/v1/getUsersByFlowId?username=${id}`
    const HEADER: RequestInit = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json",
        }
    }

    try
    {
        const response = await fetch(URL, HEADER)
        const responseJson = await response.json()

        if (response.ok)
        {
            const responseData: APIResponseUsersByUsername[] = responseJson as APIResponseUsersByUsername[]
            return {status: true, data: responseData, message: "users found"}
        }
        else 
        {
            return {status: false, data: [], message: "failed to get users"}
        }
    }
    catch (error)
    {
        console.error("failed to retrieve users by workflow id with error [", error, "]")
        return {status: false, data: [], message: "failed to get users"}
    }
}

export type APIResponseGetRecipientRequestTypes = {
    recipient: string;
    username: string;
    department: string;
}

export const APICallGetAllRecipientRequest = async (catCode: string, username: string): Promise<{status: boolean, data: APIResponseGetRecipientRequestTypes[], message: string}> => {
    const URL: string = `${BASE_URL}/ew/api/v1/getSelectedRecipientsWithUsername?catCode=${catCode}&username=${username}`
    const HEADER: RequestInit = {
        method: "GET",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json"
        }
    }

    try {
        const response = await fetch(URL, HEADER);
        const responseData = await response.json()

        if (response.ok) {
            const newResponse: ResponseTypes = responseData as ResponseTypes
            return {status: true, data: newResponse.data, message: newResponse.message}
        }
        else 
        {
            return {status: false, data: [], message: "failed to get data"}
        }
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}

export type APIRequestSaveRecipientType = {
    workflow: string;
    user: string;
    recipients: string[];
}

export const APIRequestSaveRecipients = async (body: APIRequestSaveRecipientType) => {
    const URL: string = `${BASE_URL}/ew/api/v1/save_recipients`
    const HEADER: RequestInit = {
        method: "POST",
        headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    }

    try {
        
        const response = await fetch(URL, HEADER);
        const responseData = await response.json();

        if (response.ok) {
            const newResponse: ResponseTypes = responseData as ResponseTypes
            return true
        }
        else 
        {
            return false
        }
    } catch (error) {
        console.error("API call error:", error);
        throw error;
    }
}